if (!customElements.get('th-mode-video')) {
  customElements.define('th-mode-video', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.update = () => {
        if (!this.visible || document.hidden || this.motion.matches || navigator.connection?.saveData) {
          this.video.pause();
          return;
        }
        if (!this.video.hasAttribute('src')) this.video.src = this.video.dataset.src;
        this.video.play().catch(() => {});
      };
      this.motion.addEventListener('change', this.update, options);
      document.addEventListener('visibilitychange', this.update, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.update();
      }, {rootMargin: '100px'});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.video?.pause();
      this.controller = null;
    }
  });
}
